import { render, staticRenderFns } from "./custom-tooltip.vue?vue&type=template&id=229222ba&scoped=true&"
import script from "./custom-tooltip.vue?vue&type=script&lang=js&"
export * from "./custom-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./custom-tooltip.vue?vue&type=style&index=0&id=229222ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229222ba",
  null
  
)

export default component.exports